import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Icon } from 'components/ui/index';
import classNames from 'classnames';

import './actions_dropdown.scss';

const ActionsDropdown = ({ actions = [], className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);

  const filteredActions = actions.filter((action) => action.show);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onMouseDown = (e) => {
      const inSelf = rootRef.current && rootRef.current.contains(e.target);
      const inPopover = e.target.closest && e.target.closest('.ui-popover');
      if (inSelf || inPopover) return;
      setIsOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [isOpen]);

  if (!filteredActions.length) {
    return null;
  }

  const handleClick = (event, action) => {
    event.preventDefault();
    if (action.closeOnClick !== false) {
      setIsOpen(false);
    }
    if (action.onClick) action.onClick();
  };

  return (
    <div ref={rootRef} className={classNames('actions-dropdown', { 'actions-dropdown--open': isOpen }, className)} data-cy="actions_dropdown">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="actions-dropdown-toggle"
        aria-expanded={isOpen}
        aria-haspopup="menu"
      >
        <Icon name="horizontal-menu" />
      </button>
      {isOpen && (
        <div className="actions-dropdown-menu" role="menu">
          {filteredActions.map((action, index) => (
            <React.Fragment key={`action-dropdown-${index}`}>
              {action.to && (
                <NavLink
                  data-cy={`${action.dataCy}_action`}
                  className={classNames('actions-dropdown-item', action.color ? `text-${action.color}` : null)}
                  to={action.to}
                  onClick={() => setIsOpen(false)}
                >
                  {action.icon && <Icon name={action.icon} className="mr-1" />}
                  {action.text}
                </NavLink>
              )}
              {action.onClick && (
                <a
                  data-cy={`${action.dataCy}_action`}
                  href="#"
                  className={classNames('actions-dropdown-item', action.color ? `text-${action.color}` : null)}
                  onClick={(event) => handleClick(event, action)}
                >
                  {action.icon && <Icon name={action.icon} className="mr-1" />}
                  {action.text}
                </a>
              )}
              {action.component && (
                <span className="actions-dropdown-item">
                  {action.icon && <Icon name={action.icon} className="mr-1" />}
                  {action.component}
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

ActionsDropdown.defaultProps = {
  actions: [],
};

ActionsDropdown.propTypes = {
  actions: PropTypes.array,
  className: PropTypes.string,
};

export default ActionsDropdown;
